import { Injectable } from '@angular/core';

export class FAScoringModelQualitativeView {
  lFAScoringModelQualitativeId: number;
  lFAScoringModelId: number;
  QualitativeFactor: string;
  lFAScoringModelIndexId : number;
  FactorOptions: string;
  IsScored : number;
  DefaultOption: string;
  lCustomPropertyDataTypeId : number;
  lCustomPropertyDisplayTypeId : number;
  GroupName: string;
  DisplayOrder : number;
  ScoreFormula: string;
  FAScoringModel: string;
  lFAScoreCardIndexMapId : number;
  lFAScoreCardId : number;
  lFAScoreIndexId : number;
  Weight : number;
  lFAScoreWeightIndexId : number;
  SCIMDisplayOrder : number;
  CustomPropertyDisplayType: string;
  CustomPropertyDataType: string;
  FAScoreCard: string;
  FAScoreCardGroup: string;
  ScoreIndex: string;
  WeightIndex: string;
  ScoreCardGroupFormula: string;
  OriginalValue: string;
  AdjustedValue: string;
  Score: number;
  WeightedScore: number;
  ItemSource: string;
  ItemSourceJSON: any;

}

export class APIParam {
  Param: string;  
  sBaseYearPeriod: string;
  sBasePeriod: string;
  sTradingcounterparty: string;
  sValue: string;
}

export class QualitativeGroup {
  GroupName: string;  
}
